import { useQuery } from '@tanstack/react-query';

import OffersService, { type AccountAssetRecordType } from '~/services/OffersService';

import { offerQueryKeys } from './useGetOffer';

export function useGetAccountAssets(
  accountId: string | undefined,
  recordType: AccountAssetRecordType,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: offerQueryKeys.accountAssets(accountId, recordType),
    queryFn: async ({ signal }) => {
      const response = await OffersService.getAccountAssets(accountId, { recordType, signal });
      return response.result.assets;
    },
    enabled: enabled && !!accountId,
  });
}
